import React from "react";
import styled from "styled-components";

const EtiquetaPreview = ({
  altura,
  largura,
  fontSize,
  qrCodeSize,
  qrCodeLocation,
  textLocation,
}) => {
  const printSize = { height: altura, width: largura, fontSize };
  const qrcode =
    "data:image/png;base64,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";
  return (
    altura &&
    largura &&
    fontSize && (
      <EtiquetaContainer
        theme={{
          printSizeWidth: printSize.width * 1.4,
          printSizeHeight: printSize.height * 1.3,
        }}
      >
        <EtiquetaWrapper
          theme={{
            printSizeWidth: printSize.width * 1.45,
            printSizeHeight: printSize.height * 1.3,
          }}
        >
          <DynamicSvgText
            text={"Texto de Exemplo"}
            fontSize={printSize.fontSize}
            textLocation={textLocation}
            theme={{
              printSizeWidth: printSize.width,
              printSizeHeight: printSize.height,
              qrCode: qrCodeSize,
              qrCodeLocation: qrCodeLocation,
            }}
          />
          <QRCodeContainer
            theme={{
              printSizeWidth: printSize.width,
              printSizeHeight: printSize.height,
              qrCode: qrCodeSize,
              qrCodeLocation: qrCodeLocation,
            }}
          >
            <QRCode
              src={qrcode}
              theme={{
                printSizeWidth: printSize.width,
                printSizeHeight: printSize.height,
                qrCode: qrCodeSize,
                qrCodeLocation: qrCodeLocation,
              }}
            />
          </QRCodeContainer>
        </EtiquetaWrapper>
      </EtiquetaContainer>
    )
  );
};

const DynamicSvgText = ({ text, fontSize, textLocation, theme }) => {
  const containerStyle = {
    display: "flex",
    width: `60%`,
    justifyContent: textLocation,
    textAlign: textLocation,
    paddingLeft:'1rem'
  };

  const textStyles = {
    fontSize: `${fontSize}px`,
    fontWeight: 600,
    textTransform: 'uppercase'
  };

  return (
    <div style={containerStyle}>
      <p style={textStyles}>{text}</p>
    </div>
  );
};


const EtiquetaContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;

  background-color: #c1c1c1;

  padding: 15px;

  margin-top: 25px;

  width: fit-content;
`;

const EtiquetaWrapper = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  min-width: ${(props) => props.theme.printSizeWidth + "mm"};
  min-height: ${(props) => props.theme.printSizeHeight + "mm"};

  max-width: ${(props) => props.theme.printSizeWidth + "mm"};
  max-height: ${(props) => props.theme.printSizeHeight + "mm"};

  border: 0.5px dashed #000;
  border-radius: 10px;

  padding-top:.5rem;
  padding-bottom:.5rem;
  padding-left: 1rem;
`;

const QRCodeContainer = styled.div`
  display: flex;
  position: relative;
  width: 40%;
  max-width: 50%;

  max-height: 100%;

  img {
    object-fit: contain;
  }

  top: ${(props) => props.theme.qrCodeLocation.up}px;
  left: ${(props) => props.theme.qrCodeLocation.left}px;
`;

const QRCode = styled.img`
  height: auto;
  width: auto;
  max-height: ${(props) => props.theme.qrCode*0.85}%;
  max-width: ${(props) => props.theme.qrCode*0.85}%;
`;

export default EtiquetaPreview;
